import { useEffect } from 'react';
import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { useTerminalStepStripeContext } from '../../terminals/terminal-step-context/terminal-step-context-stripe';
import { useTerminalReadersQuery } from '../../terminals/use-terminal-readers-query';
import { CollectTerminalNavigationSwitch } from './collect-terminal-navigation-switch';
import { CollectTerminalStep } from './collect-terminal-step';
import { CollectTerminalStepV2 } from './collect-terminal-step-v2';
import { CollectTerminalStepBodyProps } from './collect-terminal.types';

export const CollectTerminalStripe = () => {
  return <CollectTerminalNavigationSwitch body={CollectTerminalStripeBody} />;
};

const CollectTerminalStripeBody = ({
  onGoBack,
  onFinishAndClose,
  onInvoiceSent,
  onPaymentSuccess,
}: CollectTerminalStepBodyProps) => {
  const {
    invoice,
    activeLocationId,
    isServerDrivenV2Enabled,
    stripeData: { stripeLocationId },
  } = useCollectPaymentMultiContext();

  const { selectedReader, setSelectedReader, tempReader, setTempReader } = useTerminalStepStripeContext();

  const locationId = invoice?.locationId || activeLocationId;

  const {
    readers,
    refetchReadersAsync,
    isLoading: isReadersLoading,
  } = useTerminalReadersQuery({
    locationId,
    stripeLocationId,
  });

  useEffect(() => {
    console.log('use server driven v2 terminals: ', isServerDrivenV2Enabled);
  }, [isServerDrivenV2Enabled]);

  if (isServerDrivenV2Enabled) {
    return (
      <CollectTerminalStepV2
        readers={readers}
        selectedReader={selectedReader}
        isReadersLoading={isReadersLoading}
        onGoBack={onGoBack}
        onInvoiceSent={onInvoiceSent}
        refetchReaders={refetchReadersAsync}
        onPaymentSuccess={onPaymentSuccess}
        setSelectedReader={setSelectedReader}
        tempReader={tempReader}
        setTempReader={setTempReader}
        onFinishAndClose={onFinishAndClose}
      />
    );
  }

  return (
    <CollectTerminalStep
      readers={readers}
      selectedReader={selectedReader}
      isReadersLoading={isReadersLoading}
      onGoBack={onGoBack}
      onInvoiceSent={onInvoiceSent}
      refetchReaders={refetchReadersAsync}
      onPaymentSuccess={onPaymentSuccess}
      setSelectedReader={setSelectedReader}
      tempReader={tempReader}
      setTempReader={setTempReader}
      onFinishAndClose={onFinishAndClose}
    />
  );
};
